import TreePointsMoreIcon from "@assets/icons/Generals/TreePointsMoreIcon"
import { columnsOrderedTable } from "@thelpers/columnsTableHelper"
import CustomDropdown from "@UI/CustomDropdown"
import { dropdownCollectionAdministrationItems } from "./dropdownItems"
import FeatureButton from "@tcomponents/FeatureButton/FeatureButton"
import { COLLECTION_ADMINISTRATION_CODES } from "@constants/modules/collectionAdministration/collectionAdministrationCodes"

export const columnsCollectionHistoryTableHelper = ({
    columns = [],
    location,
    handleRedirectTo,
    onDelete,
}) => {

    const defaultColumns = [
        {
            title: 'Fecha de emisión',
            dataIndex: 'issue_date',
            key: 'issue_date',
        },
        {
            title: 'Fecha de vencimiento',
            dataIndex: 'due_date',
            key: 'due_date',
        },
        {
            title: 'Estatus',
            dataIndex: 'status_name',
            key: 'status_name',
            render: (_, record) => {
                return (
                    <span
                        className="collection-history-table-status"
                        style={{ backgroundColor: record?.status_color, color: '#1A1A1A' }}
                    >
                        {record.status_name}
                    </span>
                )
            }
        },
        {
            dataIndex: "pending_debtors",
            key: "pending_debtors",
            title: "Deudores pendientes"
        },
        {
            dataIndex: "paid_off_debtors",
            key: "paid_off_debtors",
            title: "Deudores solventes"
        },
        {
            dataIndex: "amount_collected",
            key: "amount_collected",
            title: "Cantidad recaudada"
        },
        {
            title: "Acción",
            width: '225px',
            render: (_, record) => {
                return (
                    <div className="collection-administration-table-action">
                        <FeatureButton
                            code={COLLECTION_ADMINISTRATION_CODES.COLLECTION_ADMINISTRATION_CHECK_DETAIL_PAYMENT}
                            style={{ maxWidth: '165px' }}
                            className="btn-standard-white btn-feature-payments-disabled"
                            shape="round"
                            //TO DO: Cambiar la ruta
                            onClick={() => handleRedirectTo(`/administration-collection/received-payments/${record?.charge_instance_id}`, {
                                currentCharge: location.state?.currentCharge
                            })}
                        >
                            VER
                        </FeatureButton>
                        <CustomDropdown
                            typeShowMenu='click'
                            items={dropdownCollectionAdministrationItems({
                                charge_instance_id: record?.charge_instance_id,
                                onDelete
                            })}
                            styleMenu={{ width: 124 }}
                        >
                            <div>
                                <TreePointsMoreIcon color="#A4A4A4" />
                            </div>
                        </CustomDropdown>
                    </div>
                )
            }
        },
    ]

    return columns.length ? columnsOrderedTable({
        defaultColumns,
        backendColumns: columns,
        titleUpperCase: true,
        ignoreColumns: ['status_code']
    }) : defaultColumns
}

export const columnsCollectionHistoryTableFilters = ({ currentParams }) => {
    const sort_order = currentParams?.sort_order === 'desc' ? 'descend' : 'ascend'

    return {
        issue_date: () => ({
            sorter: (a, b) => {

            },
            sortDirections: ["descend", "ascend"],
            sortOrder: currentParams?.sort_by === 'issue_date' ? sort_order : null,
        }),
        due_date: () => ({
            sorter: (a, b) => {

            },
            sortDirections: ["descend", "ascend"],
            sortOrder: currentParams?.sort_by === 'due_date' ? sort_order : null,
        }),
        pending_debtors: () => ({
            sorter: (a, b) => {

            },
            sortDirections: ["descend", "ascend"],
            sortOrder: currentParams?.sort_by === 'pending_debtors' ? sort_order : null,
        }),
        paid_off_debtors: () => ({
            sorter: (a, b) => {

            },
            sortDirections: ["descend", "ascend"],
            sortOrder: currentParams?.sort_by === 'paid_off_debtors' ? sort_order : null,
        }),
        amount_collected: () => ({
            sorter: (a, b) => {

            },
            sortDirections: ["descend", "ascend"],
            sortOrder: currentParams?.sort_by === 'amount_collected' ? sort_order : null,
        }),
        default: () => ({}),
    }
}